export default function(startup: () => any) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startup);
    } else {
        startup();
        document.removeEventListener('DOMContentLoaded', startup);
    }
}
